import React from "react";
import mastercard from "../../Assets/Images/payments/master-card.svg";
import amex from "../../Assets/Images/payments/amex.svg";
import unionpay from "../../Assets/Images/payments/union-pay.svg";
import styles from "./payment.module.css";

/** Preview logos shown when the Cards row is collapsed (total accepted networks used for "+ N"). */
const PREVIEW_SOURCES = [
  mastercard,
  amex,
  unionpay,
];
const TOTAL_REPRESENTED_BRANDS = 9;

export default function CollapsedSchemeBrands() {
  const plusCount = Math.max(0, TOTAL_REPRESENTED_BRANDS - PREVIEW_SOURCES.length);

  return (
    <span className={styles.schemeCollapsedBrands}>
      <span className={styles.schemeCollapsedLogos}>
        {PREVIEW_SOURCES.map((src, index) => (
          <img
            key={index}
            src={src}
            alt=""
            className={styles.schemeCollapsedLogo}
          />
        ))}
      </span>
      {plusCount > 0 ? (
        <span className={styles.schemeCollapsedMore}>+ {plusCount}</span>
      ) : null}
    </span>
  );
}
